import { Roles } from './roles.enum';

export class ApplicationUser {
    nameId?: string;
    uniqueName?: string;
    givenName?: string;
    familyName?: string;
    email?: string;
    asvzId?: number;
    imId?: number;
    roles?: Array<string>;

    public isAuthenticated() {
        return (this.nameId != null);
    }

    public isAdmin(): boolean {
        if (this.hasRole(Roles.Admin)) return true;
        if (this.hasRole(Roles.Office)) return true;
        return false;
    }

    public isStaff(): boolean {
        if (this.hasRole(Roles.Hausdienst)) return true;
        if (this.hasRole(Roles.Trainingsleiter)) return true;
        return false;
    }

    public isStaffOrAdmin(): boolean {
        if (this.isAdmin()) return true;
        if (this.isStaff()) return true;
        return false;
    }

    private hasRole(role: Roles): boolean {
        if (!this.roles) return false;

        const target = role.toString().toLowerCase();
        return this.roles.some(r => r.toLowerCase() === target);
    }
}

